import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useOutletContext, useSearchParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import jsPDF from "jspdf";

const fairbanner = require("./../assets/img/fair-banner.png");
const logo = require("./../assets/img/puma-logo.png");
const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;

const FairTradeProductsAll = () => {
    // Sidebar filter UI state
    const [expandedGroups, setExpandedGroups] = useState({ categories: true, product_categories: true, seasons: true, prices: true });
    const [searchProductType, setSearchProductType] = useState('');
    const { user } = useAuth();
    const { selectedLanguage, langJson } = useLanguage();
    const { storeId, proCatId } = useParams();
    const [isWebView, setIsWebView] = useState(window.innerWidth > 1299);
    const [showFilters, setShowFilters] = useState(window.innerWidth > 1299);
    const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
    const [searchParams] = useSearchParams();
    const searchQuery = searchParams.get('search') || '';

    // Get store context from StoreLayout
    const outletContext = useOutletContext();
    const store = outletContext?.store;
    const isWishlisted = outletContext?.isWishlisted;
    const favouriteId = outletContext?.favouriteId;

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [category, setCategory] = useState("default"); // default category
    const [sortKey, setSortKey] = useState("default"); // default sort key
    const [allDetails, setAllDetails] = useState();
    const [wishBtn, setWishBtn] = useState(false);
    const [wishMsg, setWishMsg] = useState(false);
    const [openModal, setOpenModal] = useState();
    const [activeImage, setActiveImage] = useState();
    const [loading, setLoading] = useState(true);

    const [availableFilters, setAvailableFilters] = useState({});
    const [appliedFilters, setAppliedFilters] = useState({
        store_id: storeId,
        categories: [],
        product_categories: [],
        seasons: [],
        prices: [],
        min_price: "",
        max_price: "",
        search_term: "",
        sort_key: "newest_first"
    });



    const toggleCategory = (catId) => {
        setAppliedFilters(f => {
            let updated;
            if (!f.categories.includes(catId)) {
                updated = [...f.categories, catId];
            } else {
                updated = f.categories.filter((id) => id !== catId);
            }
            setSelectedCategories(updated);
            return { ...f, categories: updated };
        });
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}frontend/store/products`, {
                method: "POST",
                body: JSON.stringify({
                    ...appliedFilters,
                    lang: selectedLanguage,
                    user_id: user?.id,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            setProducts(data.data.products);
            setAllDetails(data.data);
            setAvailableFilters(data.data.available_filters);
            // Do NOT reset appliedFilters here, so user selections persist
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddWishlist = async (productId) => {
        if (!user) {
            $(".loginLink").click(() => {
                $(".loginPopup").addClass("active");
            });
            setOpenModal(!openModal);
        } else {
            setWishMsg(null);
            setWishBtn(true);
            try {
                const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
                    method: "POST",
                    body: JSON.stringify({
                        product_id: productId,
                        lang: selectedLanguage,
                    }),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user?.authorisation?.token}`,
                    },
                });
                const responseData = await response.json();
                if (responseData.res === true) {
                    setWishMsg(responseData.msg);
                    setWishBtn(false);
                } else {
                    setWishMsg(responseData.msg);
                    setWishBtn(false);
                }
                setTimeout(() => {
                    setWishMsg(null);
                }, 5000);
            } catch (error) {
                console.error("Error during Sign UP:", error);
                setWishBtn(false);
            }
        }
    };

    const exportToPDF = async () => {
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 15;

        // Add header
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.text("Spring Summer 2026", pageWidth / 2, 15, { align: 'center' });

        doc.setFontSize(14);
        doc.text(store?.company_name || "Products", pageWidth / 2, 23, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`${new Date().toLocaleDateString()} - Products`, pageWidth / 2, 30, { align: 'center' });

        let yPosition = 40;
        const imgWidth = 35;
        const imgHeight = 45;
        const spacing = 10;
        let productsPerRow = 2;
        let currentRow = 0;

        for (let i = 0; i < products.length; i++) {
            const product = products[i];

            // Check if we need a new page
            if (currentRow > 0 && currentRow % 4 === 0) {
                doc.addPage();
                yPosition = 20;
                currentRow = 0;
            }

            const colPosition = (i % productsPerRow) * (imgWidth + spacing + margin);
            const rowOffset = Math.floor((i % 4) / productsPerRow) * (imgHeight + spacing + 60);
            const xPosition = margin + colPosition;
            const yImg = yPosition + rowOffset;

            // Add product image
            if (product.images && product.images[0]) {
                try {
                    const imgUrl = IMAGE_URL + product.images[0].image;
                    const img = await getBase64Image(imgUrl);
                    doc.addImage(img, 'JPEG', xPosition, yImg, imgWidth, imgHeight);
                } catch (err) {
                    // Add placeholder for failed image
                    doc.setDrawColor(200);
                    doc.rect(xPosition, yImg, imgWidth, imgHeight);
                    doc.setFontSize(7);
                    doc.text('Image', xPosition + imgWidth / 2, yImg + imgHeight / 2, { align: 'center' });
                }
            } else {
                // Add placeholder if no image
                doc.setDrawColor(200);
                doc.rect(xPosition, yImg, imgWidth, imgHeight);
                doc.setFontSize(7);
                doc.text('No Image', xPosition + imgWidth / 2, yImg + imgHeight / 2, { align: 'center' });
            }

            const textYPosition = yImg + imgHeight + 3;

            // Product name
            doc.setFontSize(9);
            doc.setFont(undefined, 'bold');
            const title = product.title.substring(0, 20);
            doc.text(title, xPosition, textYPosition);

            // Product details
            doc.setFontSize(8);
            doc.setFont(undefined, 'normal');
            doc.text(`${product.article_no || 'N/A'}`, xPosition, textYPosition + 4);
            doc.text(`W: ${product.currency}${product.unit_price}`, xPosition, textYPosition + 7);
            doc.text(`R: ${product.currency}${product.price}`, xPosition, textYPosition + 10);
            doc.text(`${product.color || ''}`, xPosition, textYPosition + 13);

            if ((i + 1) % productsPerRow === 0) {
                currentRow++;
            }
        }

        // Save PDF
        const fileName = `${store?.company_name || 'Catalog'}_SS2026.pdf`;
        doc.save(fileName);
    };

    const getBase64Image = (url) => {
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = () => reject(new Error('Image read failed'));
                    reader.readAsDataURL(blob);
                })
                .catch(error => reject(error));
        });
    };

    useEffect(() => {
        fetchData();
    }, [user, appliedFilters]);

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth > 1299;
            setIsWebView(desktop);

            if (desktop) {
                setMobileFilterOpen(false);
                setShowFilters(true);
            } else {
                setShowFilters(false);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        let filtered = products;

        // Apply search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter((product) =>
                product.title?.toLowerCase().includes(query) ||
                product.description?.toLowerCase().includes(query)
            );
        }

        setFilteredProducts(filtered);
    }, [appliedFilters.categories, products, searchQuery]);

    return (

        <div className="categoryDiv productSliderMain topNew tradePrdts">
            <div className="fullContainer">
                {loading ? (
                    <HeadingSkeleton width="200px" height="28px" />
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <h3 className="storeTabHdn">{searchQuery ? `Search results for "${searchQuery}"` : 'All Products'}</h3>
                        <button
                            onClick={exportToPDF}
                            title="Export to PDF"
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '28px',
                                color: '#475168',
                                padding: '8px',
                                transition: 'transform 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                        >
                            📄
                        </button>
                    </div>
                )}



                <div style={{ float: 'left', display: 'flex', gap: '20px', width: '100%' }}>
                    {(isWebView ? showFilters : mobileFilterOpen) && (
                        <>
                            {!isWebView && (
                                <div
                                    className="filterOverlay"
                                    onClick={() => setMobileFilterOpen(false)}
                                    style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 999 }}
                                />
                            )}

                            <div
                                className={`filterSidebar ${!isWebView
                                    ? mobileFilterOpen
                                        ? "mobile-open"
                                        : "mobile-close"
                                    : ""
                                    }`}
                                style={!isWebView ? { position: 'fixed', top: 0, left: 0, height: '100%', zIndex: 1000, background: '#fff', width: '300px', overflowY: 'auto' } : {}}
                            >
                                {!isWebView && (
                                    <div className="filterSidebarHeader" style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', alignItems: 'center' }}>
                                        <div className="filterGroupHeader">Filters</div>
                                        <button
                                            type="button"
                                            className="closeFilterBtn"
                                            onClick={() => setMobileFilterOpen(false)}
                                            style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            {/* Categories Filter */}
                            <div className="filterGroup" style={{ padding: '15px' }}>
                                <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, categories: !g.categories }))}>
                                    {langJson?.categories || "Categories"}
                                </div>
                                {expandedGroups.categories && availableFilters.categories && (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                        {availableFilters.categories.map(cat => (
                                            <button
                                                key={cat.id}
                                                className={`filterButton ${selectedCategories.includes(cat.id) ? "active" : ""}`}
                                                onClick={() => toggleCategory(cat.id)}
                                            >
                                                <span className="fs-filter__label">
                                                    {langJson?.[cat.slug] ?? cat.title}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Product Categories Filter */}
                            <div className="filterGroup" style={{ padding: '15px' }}>
                                <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, product_categories: !g.product_categories }))}>
                                    {langJson?.producttype || "Product Type"}
                                </div>
                                {expandedGroups.product_categories && availableFilters.product_categories && (
                                    <>
                                        <input
                                            className="filterSearch"
                                            type="text"
                                            placeholder={langJson?.search || "Search"}
                                            value={searchProductType}
                                            onChange={e => setSearchProductType(e.target.value)}
                                            style={{ marginBottom: '8px', width: '100%' }}
                                        />
                                        <ul>
                                            {availableFilters.product_categories
                                                .filter(cat => (langJson?.[cat.slug] ?? cat.title).toLowerCase().includes(searchProductType.toLowerCase()))
                                                .map(cat => (
                                                    <li key={cat.id}>
                                                        <label className="filterOption">
                                                            <input
                                                                type="checkbox"
                                                                checked={appliedFilters.product_categories?.includes(cat.id)}
                                                                onChange={() => {
                                                                    setAppliedFilters(f => {
                                                                        let updated;
                                                                        if (!f.product_categories.includes(cat.id)) {
                                                                            updated = [...f.product_categories, cat.id];
                                                                        } else {
                                                                            updated = f.product_categories.filter(id => id !== cat.id);
                                                                        }
                                                                        return { ...f, product_categories: updated };
                                                                    });
                                                                }}
                                                            />
                                                            {langJson?.[cat.slug] ?? cat.title}
                                                        </label>
                                                    </li>
                                                ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                            <hr />

                            {/* Price Filter (always show static options) */}
                            <div className="filterGroup" style={{ padding: '15px' }}>
                                <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, prices: !g.prices }))}>
                                    {langJson?.price || "Price"}
                                </div>
                                {expandedGroups.prices && (
                                    <div style={{ marginTop: '8px' }}>
                                        <ul>
                                            {["0 – 10", "10 – 30", "30 – 50", "50 – 100", "100+"].map((label, idx) => (
                                                <li key={label}>
                                                    <label className="filterOption">
                                                        <input
                                                            type="checkbox"
                                                            checked={appliedFilters.prices?.includes(idx)}
                                                            onChange={e => {
                                                                setAppliedFilters(f => {
                                                                    let updated;
                                                                    if (e.target.checked) {
                                                                        updated = [...(f.prices || []), idx];
                                                                    } else {
                                                                        updated = (f.prices || []).filter(i => i !== idx);
                                                                    }
                                                                    return { ...f, prices: updated };
                                                                });
                                                            }}
                                                        />
                                                        {label}
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>

                            <hr />

                            {/* Seasons Filter */}
                            <div className="filterGroup" style={{ padding: '15px' }}>
                                <div className="filterGroupHeader" onClick={() => setExpandedGroups(g => ({ ...g, seasons: !g.seasons }))}>
                                    {langJson?.seasons || "Seasons"}
                                </div>
                                {expandedGroups.seasons && availableFilters.seasons && (
                                    <ul>
                                        {availableFilters.seasons.map(season => (
                                            <li key={season}>
                                                <label className="filterOption">
                                                    <input
                                                        type="checkbox"
                                                        checked={appliedFilters.seasons?.includes(season)}
                                                        onChange={() => {
                                                            setAppliedFilters(f => {
                                                                let updated;
                                                                if (!f.seasons.includes(season)) {
                                                                    updated = [...f.seasons, season];
                                                                } else {
                                                                    updated = f.seasons.filter(s => s !== season);
                                                                }
                                                                return { ...f, seasons: updated };
                                                            });
                                                        }}
                                                    />
                                                    {season}
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        </>
                    )}

                    {/* Products Grid */}
                    <div className="featureDiv productListMain" style={{ flex: 1 }}>
                        {/* Horizontal Filter Buttons */}
                        <div className="prdtFilter">
                            <button
                                className={`filterToggleBtn ${(isWebView ? showFilters : mobileFilterOpen) ? "active" : ""}`}
                                onClick={() => isWebView ? setShowFilters(!showFilters) : setMobileFilterOpen(!mobileFilterOpen)}
                            >
                                <div className="fs-filter__icon">
                                    {showFilters ?
                                        <svg className="svgicon sc-86e4b53c-0 caTARJ fslegacy-icon svgicon-font-size" focusable="false" viewBox="0 0 12 7" aria-hidden="true" role="presentation" direction="left" style={{ "--f-svg-color": "inherit", "--f-svg-fill": "none", "--f-svg-font-size": "16px" }}><path stroke="currentColor" d="M1 6.00005L6 0.994751L11 6.00005"></path></svg>
                                        :
                                        <svg className="svgicon fslegacy-icon svgicon-font-size" focusable="false" viewBox="0 0 12 12" aria-hidden="true" role="presentation" style={{ color: 'inherit', fill: 'none', fontSize: '16px' }}><path d="M9.30001 9.66659H12V10.3333H9.30001C9.14559 11.094 8.47299 11.6666 7.66667 11.6666C6.74619 11.6666 6 10.9204 6 9.99992C6 9.07944 6.74619 8.33325 7.66667 8.33325C8.47299 8.33325 9.14559 8.90584 9.30001 9.66659ZM5.30001 5.66659H12V6.33325H5.30001C5.14559 7.094 4.47299 7.66659 3.66667 7.66659C2.74619 7.66659 2 6.92039 2 5.99992C2 5.07944 2.74619 4.33325 3.66667 4.33325C4.47299 4.33325 5.14559 4.90584 5.30001 5.66659ZM10.6333 1.66659H12V2.33325H10.6333C10.4789 3.094 9.80632 3.66659 9 3.66659C8.07953 3.66659 7.33333 2.92039 7.33333 1.99992C7.33333 1.07944 8.07953 0.333252 9 0.333252C9.80632 0.333252 10.4789 0.905839 10.6333 1.66659ZM0 2.33325V1.66659H7.33333V2.33325H0ZM9 2.99992C9.55229 2.99992 10 2.5522 10 1.99992C10 1.44763 9.55229 0.999919 9 0.999919C8.44772 0.999919 8 1.44763 8 1.99992C8 2.5522 8.44772 2.99992 9 2.99992ZM0 6.33325V5.66659H2V6.33325H0ZM3.66667 6.99992C4.21895 6.99992 4.66667 6.5522 4.66667 5.99992C4.66667 5.44763 4.21895 4.99992 3.66667 4.99992C3.11438 4.99992 2.66667 5.44763 2.66667 5.99992C2.66667 6.5522 3.11438 6.99992 3.66667 6.99992ZM0 10.3333V9.66659H6V10.3333H0ZM7.66667 10.9999C8.21895 10.9999 8.66667 10.5522 8.66667 9.99992C8.66667 9.44763 8.21895 8.99992 7.66667 8.99992C7.11438 8.99992 6.66667 9.44763 6.66667 9.99992C6.66667 10.5522 7.11438 10.9999 7.66667 10.9999Z" fill="currentColor"></path></svg>
                                    }
                                </div>
                                <span className="fs-filter__label">
                                    {showFilters ? (langJson?.hidefilters || "Hide filters") : (langJson?.showfilters || "All")}
                                </span>
                            </button>

                            {availableFilters.categories && availableFilters.categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    className={`filterToggleBtn ${selectedCategories.includes(cat.id) ? "active" : ""}`}
                                    onClick={() => toggleCategory(cat.id)}
                                >
                                    <span className="fs-filter__label">
                                        {langJson?.[cat.slug] ?? cat.title}
                                    </span>
                                </button>
                            ))}
                        </div>

                        <div className="productList">
                            <ul className={`products responsiveSliderGrid ${isWebView ? (showFilters ? 'products-5-col' : 'products-6-col') : ''}`}>
                                {loading ? (
                                    Array.from({ length: 12 }).map((_, index) => (
                                        <ProductCardSkeleton key={index} />
                                    ))
                                ) : filteredProducts && filteredProducts.length > 0 ? (
                                    filteredProducts.map((product) => (
                                        <ProductCard
                                            key={product.order_no}
                                            product={product}
                                            handleAddWishlist={handleAddWishlist}
                                            isStoreView={true}
                                        />
                                    ))
                                ) : (
                                    <div className="noItemFoundClass">{langJson?.noitemsfound}</div>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default FairTradeProductsAll;
